import { gwDomain } from './domain'

const curHref = encodeURIComponent(window.location.href)

export const getSearchHref = () => {
    return `${gwDomain}/search.html?source=${curHref}`;
};

export const goSearch = () => {
    window.open(`${gwDomain}/search.html?source=${curHref}`, '_self');
};
